import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Globe, MessageCircle } from "lucide-react";
import { useI18n, STR } from "../i18n";
import { COMPANY } from "../mock";

export default function Header() {
  const { lang, setLang, t } = useI18n();
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  const forceSolid = loc.pathname !== "/";

  return (
    <header className={`hdr ${solid || forceSolid ? "solid" : ""} ${open ? "open" : ""}`}>
      <div className="container-x row">
        <Link to="/" className="logo">
          <div className="logo-mark">GA</div>
          <div>
            <div className="logo-text" style={{ fontSize: 14, lineHeight: 1 }}>Grupo Inversiones</div>
            <div className="logo-text" style={{ fontSize: 18, lineHeight: 1.1, color: "var(--gold)" }}>Altamira</div>
          </div>
        </Link>
        <nav className="nav" style={{ display: open ? "flex" : undefined }}>
          <NavLink to="/" end>{t(STR.nav.home)}</NavLink>
          <NavLink to="/empresa">{t(STR.nav.company)}</NavLink>
          <NavLink to="/catalogo">{t(STR.nav.catalog)}</NavLink>
          <NavLink to="/servicios">{t(STR.nav.services)}</NavLink>
          <NavLink to="/blog">{t(STR.nav.blog)}</NavLink>
          <NavLink to="/contacto">{t(STR.nav.contact)}</NavLink>
        </nav>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button className="langbtn" onClick={() => setLang(lang === "es" ? "en" : "es")} aria-label="Language">
            <Globe size={14} style={{ display: "inline", marginRight: 4, verticalAlign: "-2px" }} />
            {lang === "es" ? "EN" : "ES"}
          </button>
          <a href={`https://wa.me/${COMPANY.phones[0].wa}`} target="_blank" rel="noopener noreferrer"
             className="btn btn-wa" style={{ padding: "8px 14px", fontSize: 13 }}>
            <MessageCircle size={16} /> {t({ es: "Cotizar", en: "Quote" })}
          </a>
          <button className="menubtn" onClick={() => setOpen(o => !o)} aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
    </header>
  );
}
